import { onKeyStroke } from '@vueuse/core'

export function useHandleEscapeKey(handler: () => void) {
    onKeyStroke('Escape', (e) => {
        e.preventDefault()
        e.stopPropagation()

        handler()
    })
}
